import type { RichTextFieldStrapiProps } from '@/components/atoms/RichTextField/RichTextFieldStrapi';

export interface AccordionContentItem {
  header: string;
  content?: RichTextFieldStrapiProps['text'];
  text2?: RichTextFieldStrapiProps['text2'];
}

export function resolveContentBlock(
  item: AccordionContentItem,
  stripEmptyParagraphs?: (blocks: any[]) => any[]
): RichTextFieldStrapiProps {
  if (item.text2) {
    return { text2: item.text2 };
  }

  const text =
    Array.isArray(item.content) && stripEmptyParagraphs
      ? stripEmptyParagraphs(item.content)
      : item.content;

  return { text };
}
